<template>
  <nav class="app-nav">
    <nav class="sh-nav">
      <router-link
        class="sh-nav_logo"
        to="/rallies"
      >
        <img
          src="/rallyhood-logo.svg"
          alt=""
          class="sh-nav_logo_full"
        >
        <img
          src="/rallyhood-icon.svg"
          alt=""
          class="sh-nav_logo_icon"
        >
      </router-link>
      <div class="sh-nav_menu">
        <!-- Desktop items -->
        <router-link
          class="sh-nav_menu_item desktop-only"
          to="/calendar"
        >
          <i
            class="far fa-calendar"
            aria-hidden="true"
          />
          <div>My Calendar</div>
        </router-link>
        <router-link
          class="sh-nav_menu_item desktop-only"
          to="/messaging"
        >
          <i
            class="far fa-envelope"
            aria-hidden="true"
          />
          <div>Messaging</div>
        </router-link>
        <router-link
          class="sh-nav_menu_item desktop-only"
          to="/feed"
        >
          <i
            class="far fa-rss"
            aria-hidden="true"
          />
          <div>Activity</div>
        </router-link>
        <div
          class="sh-nav_menu_item desktop-only"
          :class="{ 'notifications-open': bellNotifications }"
        >
          <BellNotification @toggle-bell="toggleBell" />
          <div>Notifications</div>
        </div>
        <div
          class="desktop-only"
          style="margin-bottom: 30px"
        >
          <UserMenu />
        </div>
        <!-- Mobile/Tablet items -->
        <div class="sh-nav_menu_item mobile-only">
          <HamburgerMenu />
        </div>
        <div
          class="sh-nav_menu_item mobile-only"
          :class="{ 'notifications-open': bellNotifications }"
        >
          <BellNotification @toggle-bell="toggleBell" />
        </div>
        <div class="sh-avatar-menu mobile-only">
          <UserMenu />
        </div>
      </div>
    </nav>
    <GlobalBreadcrumb />
  </nav>
</template>

<script>
  import BellNotification from "../components/BellNotification"
  import GlobalBreadcrumb from "../components/GlobalBreadcrumb"
  import HamburgerMenu from "../components/HamburgerMenu"
  import UserMenu from "../components/UserMenu"

  export default {
    components: {
      BellNotification,
      GlobalBreadcrumb,
      HamburgerMenu,
      UserMenu,
    },
    data() {
      return {
        bellNotifications: false,
      }
    },
    methods: {
      toggleBell(newState) {
        this.bellNotifications = newState
      },
    },
  }
</script>

<style lang="scss">
  .hamburger-menu-wrapper {
    position: relative;
    cursor: pointer;
  }

  .hamburger-icon {
    font-size: 20px;
    color: #006471;
  }

  .menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 100;
  }

  @media (max-width: 960px) {
    .menu-overlay {
      background-color: rgba(51, 51, 51, 0.75);
    }
  }

  .hamburger-dropdown {
    background-color: white;
    z-index: 101;
    position: fixed;
    top: 71.03px;
    left: 16px;
    min-width: 200px;
    border-radius: 5px;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.08);
    list-style: none;
    padding: 0;

    .option {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
      text-align: left;
      font-family: "Lato", sans-serif;
    }

    .option:hover {
      background-color: #f5f5f5;
      color: #333333 !important;
    }

    .option.selected {
      font-weight: 700;
    }
  }

  @media (max-width: 768px) {
    .hamburger-dropdown {
      left: 8px;
      right: 8px;

      .option {
        font-size: 16px !important;
        padding: 10px 24px !important;
      }
      .option--sub {
        padding: 10px 24px 10px 40px !important;
      }
    }
  }

  .hamburger-dropdown > li.option:first-child {
    border-radius: 5px 5px 0 0;
  }

  .hamburger-dropdown > li.option:last-child {
    border-radius: 0 0 5px 5px;
  }

  .my-events-group {
    list-style: none;
  }

  .option--expandable {
    justify-content: space-between;
    gap: 8px;
  }

  .expand-chevron {
    font-size: 12px;
    color: #006471;
    flex-shrink: 0;
  }

  .hamburger-submenu {
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: #ffffff;
  }

  .option--sub {
    padding: 12px 16px 12px 36px;
    font-size: 14px;
  }

  /* Desktop: show desktop items, hide mobile items */
  .mobile-only {
    display: none !important;
  }

  .desktop-only {
    display: flex !important;
    align-items: center;
  }

  /* Tablet and Mobile styles */
  @media (max-width: 960px) {
    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: flex !important;
      align-items: center;
    }

    .sh-nav_menu {
      gap: 20px !important;
      justify-content: flex-end !important;
      width: auto !important;
    }
  }

  @media (max-width: 768px) {
    .avatar-menu {
      margin-bottom: 30px !important;
      margin-left: 8px;
    }
    .sh-hav_menu {
      gap: 16px !important;
    }
  }

  .sh-nav_menu_item img {
    width: 20px;
    height: 20px;
  }

  .sh-nav_menu_item i {
    font-size: 20px;
    line-height: 1;
    color: #003e48;
  }

  .sh-nav_menu_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  /* Tablet and Mobile styles */
  @media (max-width: 960px) {
    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: flex !important;
      align-items: center;
    }

    .sh-nav_menu {
      gap: 20px !important;
      justify-content: flex-end !important;
      width: auto !important;
    }
  }

  @media (max-width: 768px) {
    .avatar-menu {
      margin-bottom: 30px !important;
      margin-left: 8px;
    }
    .sh-nav_menu {
      gap: 16px !important;
    }
  }

  .bell-notification.ellipsis-button {
    right: 5px !important;
    top: 12px !important;    
  }

  #site-nav.ellipsis-button {
    right: 5px !important;
    top: 12px !important;    

    @media (max-width: 960px) {
      top: initial !important;
    }
  }
</style>
